export const _home_mini_slideshow = [
    {
      image_url: "/media/eterna/5.webp",
      show_link: "/product/eterna",
      title: "Eterna",
      title_color: "text-white",
    },
    {
      image_url: "/media/luce/2.webp",
      show_link: "/product/luce",
      title: "Luce",
      title_color: "text-white",
    },
    {
      image_url: "/media/senso/2.webp",
      show_link: "/product/senso",
      title: "Senso",
      title_color: "text-white",
    }
  ];
  